(function () {
  'use strict';

  var CART_SELECTOR = '.product-sticky-cart';

  // This asset is included by the theme layout. Avoid installing global
  // listeners on pages that do not render a sticky cart. Theme editor pages
  // stay active because sections can be inserted dynamically there.
  if (!document.querySelector(CART_SELECTOR) && !(window.Shopify && window.Shopify.designMode)) return;

  function sectionFor(cart) {
    return cart.closest('.shopify-section') || document;
  }

  function mainInputs(cart) {
    return sectionFor(cart).querySelectorAll('input[type="radio"][data-option-position]');
  }

  function variants(cart) {
    if (cart.__kneadVariants) return cart.__kneadVariants;
    try {
      cart.__kneadVariants = JSON.parse(cart.querySelector('[data-sticky-variant-json]')?.textContent || '[]');
    } catch (error) {
      cart.__kneadVariants = [];
    }
    return cart.__kneadVariants;
  }

  function selectedVariant(cart) {
    var values = Array.from(cart.querySelectorAll('[data-sticky-option-group]')).map(function (group) {
      var active = group.querySelector('[data-sticky-option].is-active');
      return active ? active.dataset.optionValue : '';
    });
    return variants(cart).find(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (value, index) {
        return String(value).trim() === String(values[index]).trim();
      });
    }) || null;
  }

  function syncVariant(cart) {
    var variant = selectedVariant(cart);
    var input = cart.querySelector('input[name="id"]');
    if (input) {
      if (input.disabled) input.disabled = false;
      var variantId = variant ? String(variant.id) : '';
      if (input.value !== variantId) input.value = variantId;
    }
    var image = cart.querySelector('.sticky-cart__content-image img');
    if (image && variant && variant.featured_image && variant.featured_image.src) {
      if (image.src !== variant.featured_image.src) image.src = variant.featured_image.src;
      if (image.srcset) image.srcset = '';
    }
  }

  function syncOptions(cart) {
    var inputs = Array.from(mainInputs(cart));
    cart.querySelectorAll('[data-sticky-option]').forEach(function (button) {
      var active = inputs.some(function (input) {
        return input.checked &&
          input.dataset.optionPosition === button.dataset.optionPosition &&
          input.value === button.dataset.optionValue;
      });
      if (button.classList.contains('is-active') !== active) button.classList.toggle('is-active', active);
      var pressed = active ? 'true' : 'false';
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    var label = cart.querySelector('[data-sticky-variant]');
    if (label) {
      var text = inputs.filter(function (input) {
        return input.checked && input.value !== 'Default Title';
      }).map(function (input) {
        return input.value.replace(/\s*\|\s*/g, ' ').replace(/\s+/g, ' ').trim();
      }).join(' · ');
      if (label.textContent !== text) label.textContent = text;
      rememberSubtitleTiers(label, text);
    }
    syncVariant(cart);
  }

  function rememberSubtitleTiers(subEl, text) {
    if (!subEl) return;
    if (!text) {
      subEl.dataset.default = subEl.dataset.noSuffix = subEl.dataset.short = '';
      return;
    }
    subEl.dataset.default = text;
    // Drop numeric size suffixes like "20in", "25 in", "10cm" — case-insensitive.
    subEl.dataset.noSuffix = text.replace(/\s+\d+\s*(in|cm)\b/gi, '');
    // Abbreviate each word to its first letter, preserving the unit separator.
    // Skip tokens that start with a digit (e.g. "20in") — they'd just abbreviate
    // to a stray "2" and bloat the tier's width without conveying meaning.
    subEl.dataset.short = text.split(/\s*·\s*/).map(function (unit) {
      return unit.split(/\s+/).filter(function (word) {
        return word && !/^\d/.test(word);
      }).map(function (word) {
        return word.charAt(0).toUpperCase();
      }).join(' ');
    }).filter(function (s) { return s.length; }).join(' · ');
  }

  function getRow1LeftWidth(cart) {
    // Row 1 column 1 of the mobile grid = sticky-cart inner width minus
    // column-gap minus price column. Measured directly off the cart so it
    // doesn't depend on the heading's own flex-basis (which can collapse
    // to its min-content under overflow and yield a self-referential maxWidth).
    var cartWidth = cart.clientWidth;
    if (!cartWidth) return 0;
    var stickyCart = cart.querySelector('.sticky-cart');
    var padX = 28;
    if (stickyCart) {
      var cs = window.getComputedStyle(stickyCart);
      padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    }
    var priceEl = cart.querySelector('.sticky-cart__desktop-price');
    var priceWidth = priceEl ? priceEl.offsetWidth : 0;
    return Math.max(0, cartWidth - padX - 12 - priceWidth);
  }

  var SUBTITLE_TIER_NAMES = ['short', 'noSuffix', 'default'];
  var TITLE_TIER_NAMES = ['short', 'noKnead', 'default'];

  function fitTitle(cart) {
    var titleEl = cart.querySelector('[data-sticky-title]');
    if (!titleEl || !titleEl.dataset) return;
    var tiers = [
      titleEl.dataset.short,
      titleEl.dataset.noKnead,
      titleEl.dataset.default
    ].filter(Boolean);
    if (!tiers.length) { cart.dataset.fitTierTitle = 'empty'; return; }

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 840px)').matches;
    var maxWidth;
    if (isMobile) {
      var stickyCart = cart.querySelector('.sticky-cart');
      var subEl = cart.querySelector('[data-sticky-variant]');
      if (!stickyCart || !cart.clientWidth) { cart.dataset.fitTierTitle = 'no-width'; return; }
      var stickyStyle = window.getComputedStyle(stickyCart);
      var padX = (parseFloat(stickyStyle.paddingLeft) || 0) +
        (parseFloat(stickyStyle.paddingRight) || 0);
      var subtitleWidth = subEl ? subEl.getBoundingClientRect().width : 0;
      var cssMaxWidth = parseFloat(window.getComputedStyle(titleEl).maxWidth) || Infinity;
      maxWidth = Math.min(cssMaxWidth, cart.clientWidth - padX - 10 - subtitleWidth);
    } else {
      var colWidth = getRow1LeftWidth(cart);
      if (!colWidth) { cart.dataset.fitTierTitle = 'no-width'; return; }
      maxWidth = colWidth - 58;
    }
    if (!maxWidth || maxWidth <= 0) { cart.dataset.fitTierTitle = 'no-width'; return; }
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (titleEl.textContent !== tiers[i]) titleEl.textContent = tiers[i];
      if (titleEl.scrollWidth <= maxWidth) {
        cart.dataset.fitTierTitle = TITLE_TIER_NAMES[i] || ('tier' + i);
        return;
      }
    }
    cart.dataset.fitTierTitle = 'none-fit';
  }

  function fitSubtitle(cart) {
    var subEl = cart.querySelector('[data-sticky-variant]');
    if (!subEl || !subEl.dataset) return;
    var tiers = [
      subEl.dataset.short,
      subEl.dataset.noSuffix,
      subEl.dataset.default
    ].filter(function (t) { return t && t.length; });
    if (!tiers.length) { cart.dataset.fitTierSubtitle = 'empty'; return; }

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 840px)').matches;
    var maxWidth;
    if (isMobile) {
      // The mobile subtitle is absolutely positioned in the top-right and
      // capped at 40vw. Measuring the whole row made Duo/Clowder strings look
      // as though they fitted even while the rendered subtitle was truncated.
      // Use its computed max-width so tier selection matches the real box.
      maxWidth = parseFloat(window.getComputedStyle(subEl).maxWidth) || subEl.clientWidth;
    } else {
      var colWidth = getRow1LeftWidth(cart);
      if (!colWidth) { cart.dataset.fitTierSubtitle = 'no-width'; return; }
      maxWidth = colWidth - 58;
    }
    if (!maxWidth) { cart.dataset.fitTierSubtitle = 'no-width'; return; }
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (subEl.textContent !== tiers[i]) subEl.textContent = tiers[i];
      if (subEl.scrollWidth <= maxWidth) {
        cart.dataset.fitTierSubtitle = SUBTITLE_TIER_NAMES[i] || ('tier' + i);
        return;
      }
    }
    cart.dataset.fitTierSubtitle = 'none-fit';
  }

  function fit(cart) {
    // Tiered title/subtitle fit must run unconditionally — the price column
    // may briefly be 0 width (cart just toggled visible/hidden, layout not
    // flushed yet) but the tiered text still needs to fit the available
    // space whenever the bar next becomes visible.
    // Subtitle owns the constrained top-right slot. Reduce it first, then use
    // its final rendered width to calculate how much room remains for title.
    fitSubtitle(cart);
    fitTitle(cart);

    var content = cart.querySelector('.sticky-cart__content');
    var heading = cart.querySelector('.sticky-cart__content-heading .h4');
    var price = Array.from(cart.querySelectorAll('.price-container')).find(function (item) {
      return item.offsetWidth > 0;
    });
    if (!content || !heading || !price) return;
    cart.classList.remove('sticky-cart--hide-selection', 'sticky-cart--hide-discount');
    if (heading.scrollWidth > Math.max(0, content.getBoundingClientRect().width - 2)) {
      cart.classList.add('sticky-cart--hide-selection');
    }
    var desktopPrice = cart.querySelector('.sticky-cart__desktop-price');
    if ((!desktopPrice || desktopPrice.offsetWidth === 0) &&
        price.scrollWidth > Math.max(0, content.getBoundingClientRect().width - 8)) {
      cart.classList.add('sticky-cart--hide-discount');
    }
  }

  function syncBundle(cart, state) {
    var section = sectionFor(cart);
    var bundle = section.querySelector('[data-kq-vb]');
    state = state || (bundle && bundle.__kqBundleState);
    if (state) {
      function compactMoney(value) {
        return String(value || '').replace(/\.00(?=\D|$)/, '');
      }
      var isMulti = Number(state.quantity) > 1;
      if (cart.classList.contains('sticky-cart--bundle-multi') !== isMulti) {
        cart.classList.toggle('sticky-cart--bundle-multi', isMulti);
      }
      var variantLabel = cart.querySelector('[data-sticky-variant]');
      if (variantLabel && Array.isArray(state.selections) && state.selections.length) {
        var text = state.selections.join(' · ');
        if (variantLabel.textContent !== text) variantLabel.textContent = text;
        rememberSubtitleTiers(variantLabel, text);
      }
      var prices = cart.querySelectorAll('.price-container');
      prices.forEach(function (price) {
        var priceHtml =
          (state.compareAt ? '<span class="original-price">' + compactMoney(state.compareAt) + '</span>' : '') +
          '<span class="sale-price" style="font-weight:700!important">' + compactMoney(state.actual) + '</span>' +
          (state.discountPct ? '<span class="discount-badge">' + state.discountPct + '% OFF</span>' : '');
        // Keep the unparsed source string because browsers normalize inline
        // style serialization in innerHTML, which makes direct string
        // comparison report a false change on every sync.
        if (price.__kneadPriceHtml !== priceHtml) {
          price.innerHTML = priceHtml;
          price.__kneadPriceHtml = priceHtml;
        }
      });
      var submit = cart.querySelector('.product-form__submit');
      var mainButton = section.querySelector('.kq-vb__atc');
      if (submit && mainButton) {
        if (submit.disabled === !!state.available) submit.disabled = !state.available;
        // Mobile folds the price into the button label ("Add · $99",
        // "Preorder · $XX", or "Sold out") so the dedicated price column
        // can stay hidden. Desktop keeps the main button text verbatim.
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 840px)').matches;
        if (isMobile) {
          if (!state.available) {
            if (submit.textContent !== 'Sold out') submit.textContent = 'Sold out';
          } else {
            var mainText = mainButton.textContent.trim();
            var prefix = mainText.indexOf('Preorder') === 0 ? 'Preorder · ' : 'Add · ';
            var mobileText = prefix + compactMoney(state.actual);
            if (submit.textContent !== mobileText) submit.textContent = mobileText;
          }
        } else {
          var desktopText = mainButton.textContent.trim();
          if (submit.textContent !== desktopText) submit.textContent = desktopText;
        }
      }
    }
  }

  function footerInView() {
    var footer = document.querySelector('#shopify-section-footer, footer');
    return !!footer && footer.getBoundingClientRect().top < window.innerHeight;
  }

  function currentCart() {
    return document.querySelector(CART_SELECTOR);
  }

  // Zowie renders the real launcher inside the open shadow root of
  // <zowie-widget>. Move only that launcher (not the full-screen chat iframe)
  // and derive the offset from the sticky bar's rendered height so desktop,
  // mobile, and multi-item layouts all clear it correctly.
  function adjustZowieWidget(isActive, cart) {
    var launchers = Array.from(document.querySelectorAll(
      '#zowie-chat-button, zowie-chat-button, [class*="zowie-chat-button"]'
    ));
    document.querySelectorAll('zowie-widget').forEach(function (host) {
      if (!host.shadowRoot) return;
      host.shadowRoot.querySelectorAll('#zowie-chat-button, .chat-button').forEach(function (launcher) {
        launchers.push(launcher);
      });
    });

    var uniqueLaunchers = launchers.filter(function (launcher, index, all) {
      return all.indexOf(launcher) === index;
    });
    var stickyHeight = cart ? Math.ceil(cart.getBoundingClientRect().height) : 0;
    var bottom = stickyHeight + 12;

    uniqueLaunchers.forEach(function (launcher) {
      if (isActive && stickyHeight > 0) {
        var nextBottom = bottom + 'px';
        if (launcher.style.getPropertyValue('bottom') !== nextBottom ||
            launcher.style.getPropertyPriority('bottom') !== 'important') {
          launcher.style.setProperty('bottom', nextBottom, 'important');
        }
        if (launcher.style.getPropertyValue('transition') !== 'bottom 0.25s ease' ||
            launcher.style.getPropertyPriority('transition') !== 'important') {
          launcher.style.setProperty('transition', 'bottom 0.25s ease', 'important');
        }
      } else {
        if (launcher.style.getPropertyValue('bottom')) launcher.style.removeProperty('bottom');
        if (launcher.style.getPropertyValue('transition')) launcher.style.removeProperty('transition');
      }
    });
  }

  // Zowie is loaded asynchronously (defer + type=module), so the chat
  // widget DOM may not exist when boot/update first run. Watch the body
  // for any element that looks like Zowie and re-apply the offset when
  // it appears (or when the sticky cart visibility flips later on).
  function watchZowieWidget() {
    if (window.__kneadZowieObserver) return;
    var pending = null;
    window.__kneadZowieObserver = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        var cart = currentCart();
        if (cart) adjustZowieWidget(cart.classList.contains('active'), cart);
      }, 100);
    });
    window.__kneadZowieObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Third-party survey widget (Heatmap.com — class .survey-container, anchored
  // at the bottom-right of product pages). Keep its fixed launcher above the
  // sticky cart using the cart's live rendered height.
  //
  // Two sharp edges the previous version missed:
  //   1. The widget renders inside the open shadow root of
  //      `<heatmap-survey-widget>`, so a top-level
  //      `document.querySelectorAll('.survey-container')` returns nothing.
  //      We have to walk the host's shadowRoot.
  //   2. The .survey-container wrapper itself is `position: static` — writing
  //      `bottom: <px> !important` on it is a no-op. The actual visible
  //      bubble (`.display-bubble-bt-right`, an SVG launcher) is the only
  //      `position: fixed` descendant in the shadow root, so we measure and
  //      adjust that element directly. This is the "accurate positioning"
  //      the user asked for: we never infer offsets from sibling elements.
  function collectSurveyFixed() {
    var fixed = [];
    function pushFixed(root) {
      if (!root || !root.querySelectorAll) return;
      var nodes = root.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.shadowRoot) pushFixed(n.shadowRoot);
        if (window.getComputedStyle(n).position === 'fixed') {
          fixed.push(n);
        }
      }
    }
    // 1) Top-level .survey-container (in case the widget ever escapes its
    //    shadow root — cheap to check).
    var topLevel = document.querySelectorAll('.survey-container');
    for (var i = 0; i < topLevel.length; i++) pushFixed(topLevel[i]);
    // 2) The Heatmap custom element host. Its shadow root holds both the
    //    bubble launcher and (when expanded) the survey panel.
    var hosts = document.querySelectorAll('heatmap-survey-widget');
    for (var j = 0; j < hosts.length; j++) {
      if (hosts[j].shadowRoot) pushFixed(hosts[j].shadowRoot);
    }
    return fixed;
  }

  function adjustSurveyContainer(isActive, cart) {
    var fixed = collectSurveyFixed();
    if (!fixed.length) return;

    var stickyHeight = cart ? Math.ceil(cart.getBoundingClientRect().height) : 0;
    var gap = 12;
    var bottom = stickyHeight + gap;

    fixed.forEach(function (el) {
      if (!isActive || stickyHeight <= 0) {
        // Sticky cart isn't visible — restore whatever positioning the
        // third-party widget shipped with. Removing the inline overrides
        // (rather than setting a default) keeps the survey's own bottom
        // value intact for non-product pages and when the user dismisses
        // the bar again.
        if (el.style.getPropertyValue('bottom')) el.style.removeProperty('bottom');
        if (el.style.getPropertyValue('transition')) el.style.removeProperty('transition');
        return;
      }

      var nextBottom = bottom + 'px';
      if (el.style.getPropertyValue('bottom') !== nextBottom ||
          el.style.getPropertyPriority('bottom') !== 'important') {
        el.style.setProperty('bottom', nextBottom, 'important');
      }
      if (el.style.getPropertyValue('transition') !== 'bottom 0.25s ease' ||
          el.style.getPropertyPriority('transition') !== 'important') {
        el.style.setProperty('transition', 'bottom 0.25s ease', 'important');
      }
    });
  }

  // .survey-container (and the heatmap-survey-widget host) is injected
  // asynchronously by the third-party script, and the survey panel renders
  // inside a shadow root whose mutations don't bubble to a body-level
  // observer. Watch for both: body-level childList for host insertion, plus
  // per-shadow-root observers for expand/collapse and any later host
  // additions.
  function watchSurveyShadow(host) {
    if (!host || !host.shadowRoot || host.__kneadSurveyShadowObserver) return;
    var pending = null;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        var cart = currentCart();
        if (cart) adjustSurveyContainer(cart.classList.contains('active'), cart);
      }, 100);
    });
    obs.observe(host.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    host.__kneadSurveyShadowObserver = obs;
  }

  function watchSurveyContainer() {
    if (window.__kneadSurveyObserver) return;
    var pending = null;
    function attachHosts() {
      var hosts = document.querySelectorAll('heatmap-survey-widget');
      hosts.forEach(function (host) { watchSurveyShadow(host); });
      return hosts.length > 0;
    }
    function containsSurveyHost(node) {
      if (!node || node.nodeType !== 1) return false;
      return (node.matches && node.matches('heatmap-survey-widget')) ||
        (node.querySelector && node.querySelector('heatmap-survey-widget'));
    }
    window.__kneadSurveyObserver = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(containsSurveyHost);
      });
      if (!relevant) return;
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        if (!attachHosts()) return;
        var cart = currentCart();
        if (cart) adjustSurveyContainer(cart.classList.contains('active'), cart);
      }, 100);
    });
    window.__kneadSurveyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    // Attach immediately when the widget already exists. The lightweight body
    // observer remains as a replacement-host fallback, but ignores unrelated
    // DOM mutations.
    attachHosts();
  }

  function updateVisibility(cart) {
    var section = sectionFor(cart);
    var mainButton = section.querySelector('.kq-vb__atc, .product-form__submit[name="add"]');
    // Visibility rules differ by viewport:
    //   Desktop (>=841px): show whenever the main Add-to-cart button is
    //     off-screen (above or below) and the footer isn't covering the bar.
    //   Mobile (<=840px): show only after the user has scrolled past the
    //     button (rect.bottom <= 0) so the bar never appears when the user
    //     is still above the buybox or has scrolled past the page.
    var show = false;
    if (mainButton) {
      var rect = mainButton.getBoundingClientRect();
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 840px)').matches;
      var inView = rect.bottom > 0 && rect.top < window.innerHeight;
      if (!inView && !footerInView()) {
        show = isMobile ? rect.bottom <= 0 : true;
      }
    }
    var wasActive = cart.classList.contains('active');
    if (wasActive !== show) {
      cart.classList.toggle('active', show);
      cart.classList.toggle('hidden', !show);
    }
    var ariaHidden = show ? 'false' : 'true';
    if (cart.getAttribute('aria-hidden') !== ariaHidden) cart.setAttribute('aria-hidden', ariaHidden);
    if (wasActive === show) return;

    // Widget offsets only need to change when the bar changes visibility.
    // ResizeObserver handles subsequent sticky-cart height changes.
    adjustZowieWidget(show, cart);
    adjustSurveyContainer(show, cart);
  }

  function syncState(cart) {
    syncOptions(cart);
    syncBundle(cart);
    fit(cart);
  }

  function boot() {
    document.querySelectorAll(CART_SELECTOR).forEach(function (cart) {
      if (cart.__kneadStickyReady) return;
      cart.__kneadStickyReady = true;
      cart.setAttribute('data-knead-sticky-ready', 'true');
      var input = cart.querySelector('input[name="id"]');
      if (input) input.disabled = false;

      // Auto-fit whenever the cart's box size changes. Catches window resize,
      // viewport rotation, font swap (TestSoehne swap changes text widths),
      // and the cart just becoming visible (when sticky-cart toggles between
      // its translated-down and translated-up states, the rendered width
      // sometimes flips as the layout settles).
      if (typeof ResizeObserver !== 'undefined' && !cart.__kneadResizeObserver) {
        cart.__kneadResizeObserver = new ResizeObserver(function () {
          requestAnimationFrame(function () {
            fit(cart);
            adjustZowieWidget(cart.classList.contains('active'), cart);
            adjustSurveyContainer(cart.classList.contains('active'), cart);
          });
        });
        cart.__kneadResizeObserver.observe(cart);
      }

      // Custom fonts can change text widths after initial layout. Re-fit when
      // the font face set is ready.
      if (document.fonts && document.fonts.ready && !cart.__kneadFontsFit) {
        cart.__kneadFontsFit = true;
        document.fonts.ready.then(function () {
          requestAnimationFrame(function () { fit(cart); });
        });
      }

      // Watch the body for the Zowie chat widget DOM (loaded async) and
      // re-apply the sticky-cart offset whenever Zowie elements appear.
      watchZowieWidget();
      // Same for the third-party .survey-container widget — it loads
      // asynchronously and its internal DOM mutates when the user
      // expands/collapses the survey, so we need to re-measure its
      // actual height on every relevant change.
      watchSurveyContainer();

      syncState(cart);
      updateVisibility(cart);
    });
  }

  function updateVisibilityAll() {
    document.querySelectorAll(CART_SELECTOR).forEach(updateVisibility);
  }

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-sticky-option]');
    if (option) {
      var cart = option.closest(CART_SELECTOR);
      var input = Array.from(mainInputs(cart)).find(function (candidate) {
        return candidate.dataset.optionPosition === option.dataset.optionPosition &&
          candidate.value === option.dataset.optionValue;
      });
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var submit = event.target.closest(CART_SELECTOR + ' .product-form__submit');
    if (submit) {
      var stickyCart = submit.closest(CART_SELECTOR);
      var bundleButton = sectionFor(stickyCart).querySelector('.kq-vb__atc');
      if (bundleButton) {
        event.preventDefault();
        bundleButton.click();
      }
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[type="radio"][data-option-position]')) return;
    var section = event.target.closest('.shopify-section') || document;
    var cart = section.querySelector(CART_SELECTOR);
    if (cart) requestAnimationFrame(function () {
      syncState(cart);
      updateVisibility(cart);
    });
  });

  document.addEventListener('kq:bundle-change', function (event) {
    var section = event.target.closest('.shopify-section') || document;
    var cart = section.querySelector(CART_SELECTOR);
    if (cart) {
      syncBundle(cart, event.detail);
      fit(cart);
    }
  });

  var frame = null;
  function scheduleVisibilityUpdate() {
    if (frame !== null) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      updateVisibilityAll();
    });
  }

  function start() {
    boot();
    if (!currentCart()) return;
    attachViewportListeners();
    updateVisibilityAll();
  }

  function attachViewportListeners() {
    if (window.__kneadStickyViewportBound) return;
    window.__kneadStickyViewportBound = true;
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisibilityUpdate);
  }

  function detachViewportListeners() {
    if (!window.__kneadStickyViewportBound) return;
    window.__kneadStickyViewportBound = false;
    window.removeEventListener('scroll', scheduleVisibilityUpdate);
    window.removeEventListener('resize', scheduleVisibilityUpdate);
  }

  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target;
    var carts = [];
    if (container && container.matches && container.matches(CART_SELECTOR)) carts.push(container);
    if (container && container.querySelectorAll) {
      carts = carts.concat(Array.from(container.querySelectorAll(CART_SELECTOR)));
    }
    carts.forEach(function (cart) {
      if (cart.__kneadResizeObserver) cart.__kneadResizeObserver.disconnect();
      cart.__kneadResizeObserver = null;
      cart.__kneadStickyReady = false;
    });
    requestAnimationFrame(function () {
      if (!currentCart()) detachViewportListeners();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
